module.exports = __webpack_public_path__ + "static/hassan-8c148ab95939de24c6a8c46c26afb3eb.png";